import {Multicall,ContractCallResults,ContractCallContext} from 'ethereum-bsc-multicall';
import {getTokenAbi} from '../app/tokenAbi'

const tokenAbi = getTokenAbi()
const multicall = new Multicall({
    nodeUrl: 'https://bsc-dataseed.binance.org/'
})

export const createSymContext = async (listOfLpTokenPairs:any, poolIndexArr:any) => {
    try{
        const symCallContext: ContractCallContext<{}>[] = await listOfLpTokenPairs.map((token:any,i:any) => {
                return {
                    reference: `${i}`,
                    contractAddress: `${token}`,
                    abi: tokenAbi,
                    calls: [
                        { 
                            reference: `${token}`, 
                            methodName: `symbol`, 
                            methodParameters: [] 
                        },
                        { 
                            reference: `getSupply`, 
                            methodName: `totalSupply`, 
                            methodParameters: [] 
                        },
                    ],
                    context:{
                        poolIndex: poolIndexArr[i],
                        token: i % 2
                    }
                }   
        })
        const response = multicall.call(symCallContext)
        const results: ContractCallResults = await response
        return results
    } catch(error){
        console.log(error)
    }
}
